import { gql } from '@apollo/client';

/**
 * V1e · Queries/mutations admin pour la modération des credentials.
 *
 * Réutilise les resolvers livrés en V1d :
 *   - Query  credentialVerificationQueue (paginated FIFO)
 *   - Mutation reviewCredentialVerification
 *
 * Le filtrage role ADMIN/MODERATOR est appliqué côté résolveur
 * (cf. `apps/api/src/credential-verification/credential-verification.resolver.ts`).
 */

export const GET_CREDENTIAL_VERIFICATION_QUEUE = gql`
  query CredentialVerificationQueueAdmin(
    $status: CredentialVerificationStatus
    $type: CredentialVerificationType
    $limit: Int
    $offset: Int
  ) {
    credentialVerificationQueue(
      status: $status
      type: $type
      limit: $limit
      offset: $offset
    ) {
      items {
        id
        userId
        digitalCardId
        type
        fieldRef
        fieldSnapshot
        documentUrl
        documentMimeType
        documentSize
        submissionNote
        status
        reviewedByUserId
        reviewedAt
        reviewNote
        rejectReason
        submittedAt
        updatedAt
      }
      total
    }
  }
`;

export const REVIEW_CREDENTIAL_VERIFICATION = gql`
  mutation ReviewCredentialVerificationAdmin(
    $verificationId: String!
    $input: ReviewCredentialVerificationInput!
  ) {
    reviewCredentialVerification(
      verificationId: $verificationId
      input: $input
    ) {
      id
      status
      reviewedAt
      reviewNote
      rejectReason
    }
  }
`;

/**
 * V1e+ · Stats agrégées de la queue de modération.
 *
 * `windowDays` (default 30 côté BE si non fourni) limite l'échantillon
 * pour `avgModerationTimeHours` et `topReviewers`. Les counts par status
 * sont globaux (non filtrés par fenêtre).
 */
export const GET_CREDENTIAL_MODERATION_STATS = gql`
  query CredentialModerationStatsAdmin($windowDays: Int) {
    credentialModerationStats(windowDays: $windowDays) {
      countPending
      countUnderReview
      countApproved
      countRejected
      avgModerationTimeHours
      topReviewers {
        userId
        reviewedCount
      }
      windowDays
    }
  }
`;
